Fancybox.bind("[data-fancybox]");